import { render, staticRenderFns } from "./job-openings.vue?vue&type=template&id=e85fae88&scoped=true"
import script from "./job-openings.vue?vue&type=script&lang=js"
export * from "./job-openings.vue?vue&type=script&lang=js"
import style0 from "./job-openings.vue?vue&type=style&index=0&id=e85fae88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85fae88",
  null
  
)

export default component.exports